import { FeesGuideStruct } from "../../structs/private-billing/fees-guide.struct";
export class FeesGuideRequest {
    public feesGuideStruct: FeesGuideStruct;
}